// extracted by mini-css-extract-plugin
var _1 = "ImageToolbar-module__betaBadgeContainer--iYg_Z";
var _2 = "ImageToolbar-module__betaMenuItem--hMW8G";
export { _1 as "betaBadgeContainer", _2 as "betaMenuItem" }
